import { h } from "vue";

import GenericCard from "@/components/EntityInfo/GenericCard.vue";
import { type BusinessEntity } from "@/stores/business-entities-store";
import { EntityType } from "@/stores/entity-store";
import { vnodeToHtml } from "@/utils";

import {
    LinkedEntity,
    createEntityExtension,
} from "../mystekz-linked-entities";
import { BusinessEntitiesManager } from "./manager";

export type BusinessEntityEntity = LinkedEntity<
    "business_entity",
    BusinessEntity
>;

let businessEntityManager: BusinessEntitiesManager;
/**
 * Get the business entity manager for a given domain.
 */
export const getBusinessEntitiesManager = (baseUrl: string) => {
    if (!businessEntityManager) {
        businessEntityManager = new BusinessEntitiesManager(baseUrl);
    }
    return businessEntityManager;
};

export const BusinessEntitiesExtension = createEntityExtension(
    "business_entity",
    import.meta.env.VITE_BASE_URL,
    true,
    {
        popup: {
            key: "businessEntityDetails",
            hover: true,
            create: (
                _: Promise<BusinessEntityEntity | void>,
                entityId: string
            ) => {
                return () => {
                    return vnodeToHtml(
                        h(GenericCard, {
                            entityId,
                            entityType: EntityType.BUSINESS_ENTITY,
                        })
                    );
                };
            },
        },
        prefix: "",
    },
    {
        popup: {
            key: "businessEntityInsert",
        },
        prefix: "[",
    },
    getBusinessEntitiesManager,
    {
        label: "Domain Objects",
        showInInlineMenu: true,
        caret: true,
        icon: {
            name: "plus-square",
        },
        group: "References",
    }
);
